import axios from "axios";

/**
 * Custom hook to provide Microsoft Graph API helpers using MSAL authentication.
 * Usage: Call these functions inside a React component or another custom hook.
 */
export const useGraphApi = (instance: any, accounts: any) => {

  // Helper to get an access token for Graph API
  const getGraphAccessToken = async (scopes = ["User.Read.All"]) => {
    if (!accounts || accounts.length === 0) throw new Error("No accounts found");
    const response = await instance.acquireTokenSilent({
      scopes,
      account: accounts[0],
    });
    return response.accessToken;
  };

  // Get a single user by username (with manager info)
  const getUserWithManager = async (username: any) => {
    const token = await getGraphAccessToken();
    const res = await axios.get(
      `https://graph.microsoft.com/v1.0/users/${username}?$expand=manager`,
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      }
    );
    return res.data;
  };

  // Get all users (basic info)
  const getAllUsers = async () => {
    const token = await getGraphAccessToken();
    let url = "https://graph.microsoft.com/v1.0/users?$select=id,displayName,mail,givenName,surname,userPrincipalName,jobTitle,userType,accountEnabled&$expand=manager";
    let allUsers: any[] = [];

    while (url) {
        const res = await axios.get(url, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
        });
        const users = res.data.value || [];
        allUsers = allUsers.concat(users);
        url = res.data['@odata.nextLink'] || null;
    }

    const filteredUsers = allUsers.filter((user: any) => user.userType === "Member" && user.accountEnabled);
    return (filteredUsers || []).map((user: any) => {
      const firstName = user.givenName ?? (user.displayName ? user.displayName.split(' ')[0] : null);
      const lastName = user.surname ?? (user.displayName ? user.displayName.split(' ')[1] : null);
      const managerMail = user.manager?.mail ?? null;
      return {
        mail: user.mail,
        firstName,
        lastName,
        managerMail,
      };
    });
  };

  return {
    getGraphAccessToken,
    getUserWithManager,
    getAllUsers,
  };
};
